import PropTypes from 'prop-types';
import { date } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';
import TripDetailsOvernightIndicator from './TripDetailsOvernightIndicator';

const overnightInfoStyles = css`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 8px;
  padding-top: 8px;
`;

const overnightIndicatorStyle = css`
  font-size: 0.725rem;
  margin-right: 6px;
  position: static;

  [dir='rtl'] & {
    margin-left: 6px;
    margin-right: 0;
  }
`;

const overnightInfoStyle = css`
  font-size: 0.725rem;

  @media ${mediaQueries.medium.up} {
    font-size: 0.75rem;
  }

  @media ${mediaQueries.large.up} {
    font-size: 0.875rem;
  }
`;

const TripDetailsBoundOvernightInfo = ({ durationInDays, arrivalDate, format = 'EEEE d MMM' }) => {
  const { t } = useTranslation();

  return (
    <div className={overnightInfoStyles}>
      <TripDetailsOvernightIndicator
        className={overnightIndicatorStyle}
        durationInDays={durationInDays}
      />{' '}
      <span className={overnightInfoStyle}>
        {t('TripDetails.ArrivalDateText')} {date.format(arrivalDate, format)}
      </span>
    </div>
  );
};

TripDetailsBoundOvernightInfo.propTypes = {
  arrivalDate: PropTypes.string,
  durationInDays: PropTypes.number,
  format: PropTypes.string,
};

export default TripDetailsBoundOvernightInfo;
